import React from 'react';
import { Badge } from 'react-bootstrap';
import { ICON_RESERVE } from "./icons";

export const LABEL_RESERVED = props => (
    <Badge variant="danger" {...props}>
        <ICON_RESERVE /> RESERVADO
    </Badge>
)